module.exports = __webpack_public_path__ + "static/media/organize-kanban-explainer.1d86a46e.png";